import React from 'react';
import { IconClose } from './Icons';
import { BrandMark } from './BrandMark';
import './InstallPrompt.css';

/**
 * Bottom banner nudging the user to install Symphonate as an app. Rendered
 * when `open` is true (first login, or on demand from the user menu). Chrome/
 * Edge/Android get a one-tap Install button wired to the native dialog; iOS
 * Safari — which has no programmatic install — gets the manual Share → "Add to
 * Home Screen" instructions instead. A banner (not a modal) so it can coexist
 * with the first-login onboarding tour without stacking overlays.
 */
export default function InstallPrompt({ open, pwa, onClose }) {
  if (!open || !pwa) return null;

  const handleInstall = async () => {
    if (pwa.canPrompt) {
      await pwa.promptInstall();
      onClose && onClose();
    }
    // On iOS there's nothing to fire — the instructions below are the CTA.
  };

  return (
    <div className="install-prompt" role="dialog" aria-label="Install Symphonate as an app">
      <div className="install-prompt-body">
        <span className="install-prompt-icon" aria-hidden="true">
          <BrandMark size={40} />
        </span>
        <div className="install-prompt-text">
          <strong className="install-prompt-title">Install Symphonate</strong>
          {pwa.isIOS && !pwa.canPrompt ? (
            <span className="install-prompt-sub">
              Tap the Share button, then <strong>Add to Home Screen</strong> for a full-screen app.
            </span>
          ) : (
            <span className="install-prompt-sub">
              Add it to your home screen for a faster, full-screen experience.
            </span>
          )}
        </div>
      </div>
      <div className="install-prompt-actions">
        {pwa.canPrompt && (
          <button type="button" className="install-prompt-btn primary" onClick={handleInstall}>
            Install
          </button>
        )}
        <button type="button" className="install-prompt-btn dismiss" onClick={onClose}>
          {pwa.isIOS && !pwa.canPrompt ? 'Got it' : 'Not now'}
        </button>
      </div>
      <button type="button" className="install-prompt-close" onClick={onClose} aria-label="Close">
        <IconClose size={16} />
      </button>
    </div>
  );
}
